import * as AOS from 'aos/dist/aos.js';
import 'magnific-popup';
import '../autoload/_imagesloaded';
import '../autoload/_lazyloadxt';
import '../autoload/_cookiebar';

// JavaScript to be fired on all pages
var lastScroll = 0;
var limitScrollBar = 490;
var oldScorllTop = 0;
//check for browser os
var isMobile = false;
var isiPhoneiPad = false;
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  isMobile = true;
}

var pgurl = window.location.href.substr(window.location.href.lastIndexOf("/") + 1);
var $hash = window.location.hash.substring(1);

function base64_decode(encodedData) { // eslint-disable-line camelcase
                                      //  discuss at: https://locutus.io/php/base64_decode/
                                      // original by: Tyler Akins (https://rumkin.com)
                                      // improved by: Thunder.m
                                      // improved by: Kevin van Zonneveld (https://kvz.io)
                                      // improved by: Kevin van Zonneveld (https://kvz.io)
                                      //    input by: Aman Gupta
                                      //    input by: Brett Zamir (https://brett-zamir.me)
                                      // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
                                      // bugfixed by: Pellentesque Malesuada
                                      // bugfixed by: Kevin van Zonneveld (https://kvz.io)
                                      // improved by: Indigo744
                                      //   example 1: base64_decode('S2V2aW4gdmFuIFpvbm5ldmVsZA==')
                                      //   returns 1: 'Kevin van Zonneveld'
                                      //   example 2: base64_decode('YQ==')
                                      //   returns 2: 'a'
                                      //   example 3: base64_decode('4pyTIMOgIGxhIG1vZGU=')
                                      //   returns 3: '✓ à la mode'

  // decodeUTF8string()
  // Internal function to decode properly UTF8 string
  // Adapted from Solution #1 at https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
  var decodeUTF8string = function (str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(str.split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
  }

  if (typeof window !== 'undefined') {
    if (typeof window.atob !== 'undefined') {
      return decodeUTF8string(window.atob(encodedData))
    }
  } else {
    return new Buffer(encodedData, 'base64').toString('utf-8')
  }

  var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
  var o1
  var o2
  var o3
  var h1
  var h2
  var h3
  var h4
  var bits
  var i = 0
  var ac = 0
  var dec = ''
  var tmpArr = []

  if (!encodedData) {
    return encodedData
  }

  encodedData += ''

  do {
    // unpack four hexets into three octets using index points in b64
    h1 = b64.indexOf(encodedData.charAt(i++))
    h2 = b64.indexOf(encodedData.charAt(i++))
    h3 = b64.indexOf(encodedData.charAt(i++))
    h4 = b64.indexOf(encodedData.charAt(i++))

    bits = h1 << 18 | h2 << 12 | h3 << 6 | h4

    o1 = bits >> 16 & 0xff
    o2 = bits >> 8 & 0xff
    o3 = bits & 0xff

    if (h3 === 64) {
      tmpArr[ac++] = String.fromCharCode(o1)
    } else if (h4 === 64) {
      tmpArr[ac++] = String.fromCharCode(o1, o2)
    } else {
      tmpArr[ac++] = String.fromCharCode(o1, o2, o3)
    }
  } while (i < encodedData.length)

  dec = tmpArr.join('')

  return decodeUTF8string(dec.replace(/\0+$/, ''))
}

function pad(d) {
  return (d < 10) ? '0' + d.toString() : d.toString();
}

function isIE() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {  // If Internet Explorer, return version number
    return true;
  } else // If another browser, return 0
  {
    return false;
  }
}

function setPageTitleSpace() {
  if ($('.navbar').hasClass('navbar-top') || $('nav').hasClass('navbar-fixed-top')) {
    if ($('.top-space').length > 0) {
      var top_space_height = $('.navbar').outerHeight();
      if ($('.top-header-area').length > 0) {
        top_space_height = top_space_height + $('.top-header-area').outerHeight();
      }
      $('.top-space').css('margin-top', top_space_height + "px");
    }
  }
}

function init_scroll_navigate() {
  /*==============================================================*/
  //background color slider Start
  /*==============================================================*/
  var $window = $(window),
    $body = $('.bg-background-fade'),
    $panel = $('.color-code');
  var scroll = $window.scrollTop() + ($window.height() / 2);
  $panel.each(function () {
    var $this = $(this);
    if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {
      $body.removeClass(function (index, css) {
        return (css.match(/(^|\s)color-\S+/g) || []).join(' ');
      });
      $body.addClass('color-' + $(this).data('color'));
    }
  });


  /* ===================================
   sticky nav Start
   ====================================== */
  var headerHeight = $('nav').outerHeight() + 20 ;
  if (!$('header').hasClass('no-sticky')) {
    if ($(document).scrollTop() >= headerHeight) {
      $('header').addClass('sticky');

    } else if ($(document).scrollTop() <= headerHeight) {
      $('header').removeClass('sticky');
      setTimeout(function () {
        setPageTitleSpace();
      }, 500);
    }
  }

  /* ===================================
   header appear on scroll up
   ====================================== */
  var st = $(this).scrollTop();
  if (st > lastScroll) {
    $('.sticky').removeClass('header-appear');
  } else
    $('.sticky').addClass('header-appear');
  lastScroll = st;
  if (lastScroll <= headerHeight)
    $('header').removeClass('header-appear');
}

function setPhotogallery(){
  if ($('#photogallery').length > 0 && $('#mobilephotogallery').length > 0) {

    var $portfolio_filter = $('.portfolio-grid');
    var w = window.innerWidth;
    if(w > 768 && $('#photogallery').data('empty')){
      var content = $('#mobilephotogallery').html();
      $('#photogallery').html(content).show();
      $('#mobilephotogallery').empty().hide();
      $('#photogallery').data('empty',0);
    }
    else if(w <= 768 && !$('#photogallery').data('empty')){
      var content = $('#photogallery').html();
      $('#mobilephotogallery').html(content).show();
      $('#photogallery').empty().hide();
      $('#photogallery').data('empty',1);
    }
    $portfolio_filter.isotope();
  }
}

function SetResizeContent() {
  setPageTitleSpace();
  setPhotogallery();
}

export default {
  init() {

  },
  finalize() {
    this.ready();
    this.resize();

    $(document).on('load', function () {
      var hash = window.location.hash.substr(1);
      if (hash != "") {
        setTimeout(function () {
          $(document).imagesLoaded(function () {
            var scrollAnimationTime = 1200,
              scrollAnimation = 'easeInOutExpo';
            var target = '#' + hash;
            if ($(target).length > 0) {

              $('html, body').stop()
                .animate({
                  'scrollTop': $(target).offset().top
                }, scrollAnimationTime, scrollAnimation, function () {
                  window.location.hash = target;
                });
            }
          });
        }, 500);
      }
    });
  },
  ready() {
    $(document).ready(function () {
      "use strict";

      window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      });

      $(window).on("scroll", init_scroll_navigate);

      AOS.init({
        offset: 100,
        duration: 400,
        delay: 100,
        once: true,
        disable: function () {
          var maxWidth = 1024;
          return window.innerWidth < maxWidth;
        }
      });

      // Active class to current menu for only html
      var pgurl = window.location.href.substr(window.location.href.lastIndexOf("/") + 1);
      var $hash = window.location.hash.substring(1);

      if ($hash) {
        $hash = "#" + $hash;
        pgurl = pgurl.replace($hash, "");
      }
      else {
        pgurl = pgurl.replace("#", "");
      }

      $("nav .nav li a").each(function () {
        if ($(this).attr("href") == pgurl || $(this).attr("href") == pgurl + '.html') {
          $(this).parent().addClass("active");
          $(this).parents('li.dropdown').addClass("active");
        }
      });
      $("#modal-popup-menu .nav li a").each(function () {
        if ($(this).attr("href") == pgurl || $(this).attr("href") == pgurl + '.html') {
          $(this).parent().addClass("active");
          $(this).parents('li.dropdown').addClass("active");
        }
      });
      $(window).scroll(function () {
        if ($(this).scrollTop() > 150)
          $('.scroll-top-arrow').fadeIn('slow');
        else
          $('.scroll-top-arrow').fadeOut('slow');
      });
      //Click event to scroll to top
      $(document).on('click', '.scroll-top-arrow', function () {
        $('html, body').animate({scrollTop: 0}, 800);
        return false;
      });

      /*==============================================================
       smooth scroll
       ==============================================================*/

      var scrollAnimationTime = 1200, scrollAnimation = 'easeInOutExpo';
      $(document).on('click.smoothscroll', 'a.scrollto', function (event) {
        event.preventDefault();
        var target = this.hash;
        if ($(target).length != 0) {
          $('html, body').stop()
            .animate({
              'scrollTop': $(target)
                .offset()
                .top
            }, scrollAnimationTime, scrollAnimation, function () {
              window.location.hash = target;
            });
        }
      });

      // Inner links
      if ($('.navbar-top').length > 0 || $('.navbar-scroll-top').length > 0 || $('.navbar-top-scroll').length > 0) {
        $('.inner-link').smoothScroll({
          speed: 900,
          offset: 0
        });
      }
      else {
        $('.inner-link').smoothScroll({
          speed: 900,
          offset: -59
        });
      }

      $('.section-link').smoothScroll({
        speed: 900,
        offset: 1
      });

      /*==============================================================*/
      //Modal popup - START CODE
      /*==============================================================*/
      $('.modal-popup').magnificPopup({
        type: 'inline',
        preloader: false,
        blackbg: true,
        mainClass: 'my-mfp-zoom-in',
        callbacks: {
          open: function () {
            $('html').css('margin-right', 0);
            $('body,html').addClass('overflow-hidden popupopen');
          },
          close: function() {
            $('body,html').removeClass('overflow-hidden popupopen');
          }
        }
      });
      $(document).on('click', '.popup-modal-dismiss, .mfp-close', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
      });

      /*==============================================================*/
      //Modal popup - zoom animation - START CODE
      /*==============================================================*/
      $('.popup-with-zoom-anim').magnificPopup({
        type: 'inline',
        fixedContentPos: false,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        blackbg: true,
        mainClass: 'my-mfp-zoom-in'
      });

      /*==============================================================
       popup with form
       ==============================================================*/
      $('.popup-with-form').magnificPopup({
        type: 'inline',
        preloader: false,
        closeBtnInside: false,
        fixedContentPos: true,
        focus: '#name',
        callbacks: {
          beforeOpen: function () {
            if ($(window).width() < 700) {
              this.st.focus = false;
            } else {
              this.st.focus = '#name';
            }
          }
        }
      });

      /*==============================================================
       portfolio filter
       ==============================================================*/
      var $portfolio_filter = $('.portfolio-grid');
      $portfolio_filter.imagesLoaded(function () {
        $portfolio_filter.isotope({
          layoutMode: 'masonry',
          itemSelector: '.grid-item',
          percentPosition: true,
          masonry: {
            columnWidth: '.grid-sizer'
          }
        });
        $portfolio_filter.isotope();
      });

      setPhotogallery();

      /* ===================================
       left nav
       ====================================== */
      $(document).on('click', '.right-menu-button', function (e) {
        $('body').toggleClass('left-nav-on');
      });

      var $allNonRatinaImages = $("img:not([data-rjs])");
      $allNonRatinaImages.attr('data-no-retina', '');

      $(document).on("touchstart", ".sidebar-wrapper", function () {
        clearOpen();
      });

      var getNav = $("nav.navbar.bootsnav"), getIn = getNav.find("ul.nav").data("in"), getOut = getNav.find("ul.nav").data("out");
      function clearOpen() {
        $('li.dropdown').removeClass("on").removeClass("show");
        $(".dropdown-menu").stop().fadeOut('fast');
        $(".dropdown-menu").removeClass(getIn);
        $(".dropdown-menu").addClass(getOut);
      }

      /*==============================================================
       lightbox gallery
       ==============================================================*/
      if ($(window).width() > 700) {
        $('.lightbox-gallery').magnificPopup({
          delegate: 'a',
          type: 'image',
          tLoading: 'Loading image #%curr%...',
          mainClass: 'mfp-fade',
          fixedContentPos: true,
          closeBtnInside: false,
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
          }
        });
      }
      /* for group gallery */
      var lightboxgallerygroups = {};
      $('.lightbox-group-gallery-item').each(function () {
        var id = $(this).attr('data-group');
        if (!lightboxgallerygroups[id]) {
          lightboxgallerygroups[id] = [];
        }
        lightboxgallerygroups[id].push(this);
      });
      $.each(lightboxgallerygroups, function () {
        $(this).magnificPopup({
          type: 'image',
          closeOnContentClick: true,
          closeBtnInside: false,
          gallery: {enabled: true}
        });
      });


      /**
       * jQuery AUTOCOMPLETE
       * https://github.com/devbridge/jQuery-AutocompleteminChars
       */
      if ($('.search-supporto').length > 0) {
        $('.search-supporto').autocomplete({
          minChars:2,
          lookup: function (query, done) {
            var result = {
              suggestions: [
                { "value": "United Arab Emirates", "data": "AE" },
                { "value": "United Kingdom",       "data": "UK" },
                { "value": "United States",        "data": "US" }
              ]
            };

            done(result);
          },
          onSelect: function (suggestion) {
            //alert('You selected: ' + suggestion.value + ', ' + suggestion.data);
          }
        });
      }

      if ($('.form-check').length > 0) {
        jQuery('.form-check').on('click', function (e) {
          if (jQuery(e.target).hasClass('form-check')) {
            var checkBox = jQuery(this).find('.form-check-input');
            checkBox.prop("checked", !checkBox.prop("checked"));
          }
        });
      }
    });
  },
  resize() {
    $(window).resize(function (event) {
      setTimeout(function () {
        SetResizeContent();
      }, 500);

      if (isIE()) {
        setTimeout(function () {
        }, 500);
      }

      $('.navbar-collapse').collapse('hide');

      event.preventDefault();
    });

  }
}
;



// WEBPACK FOOTER //
// ./scripts/routes/common.js